import { ReferralIcon } from '@/shared/assets'
import { NavbarItem } from '../NavbarItem/NavbarItem'
import './navbarReferral.scss'
import {
    workspacePath,
    useActiveWorkspace,
} from '@/true-fsd/data/advertiser-account'

export const NavbarReferral = () => {
    const { activeWorkspace } = useActiveWorkspace()

    return (
        <div className="navbar-referral">
            <NavbarItem
                to={workspacePath(activeWorkspace, 'referral')}
                text="Реферальная программа"
                isOpen={true}
                icon={ReferralIcon}
                className="navbar-referral__item"
            />
        </div>
    )
}
